<style lang="less" scoped>
@import './main.less';
</style>

<template>
  <div class="main">
    <div class="sidebar-menu-con menu-bar">
      <shrinkable-menu :shrink="shrink" @on-change="handleSubmenuChange" :theme="menuTheme" :before-push="beforePush" :open-names="openedSubmenuArr" :menu-list="menuList">
        <div slot="top" class="logo-con" style="background:rgba(255,255,255,0)">
          <!-- <img src="../assets/logo2.png" key="max-logo" /> -->
          <!-- <img v-if="isTrial == 0" src="../assets/xxlogo.png" key="max-logo" /> -->
          <img v-if="isTrial == 0"  key="max-logo" />
          <!-- <img  v-else class="xinxilogo" src="../assets/xinxilogo.png" key="max-logo" /> -->
          <img  v-else class="xinxilogo"  key="max-logo" />
        </div>
      </shrinkable-menu>
    </div>
    <div class="main-header-con">
      <div class="main-header">
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <!-- <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav> -->
            <!-- <img src="../assets/main-header-bg.png" key="max-logo" style="width: 280px;" /> -->
          </div>
        </div>
        <div class="header-link-card-back"  v-if="schoolStatus == 1 && !currCardStatus" @click="handleClickBackMainCard">
            <Row type="flex" justify="end" align="middle" class="ae">
                <Icon type="md-arrow-round-back"/>返回主学习卡
            </Row>
        </div>
        <div class="header-link-card"  v-if="schoolStatus == 1 && currCardStatus">
            <Row type="flex" justify="end" align="middle" class="ae" style="cursor:pointer;">
            <Dropdown transfer trigger="hover"  @on-click="handleClickAdditionalCardDropdown">
              <a class="link-card-title">
                 <Icon type="md-infinite"/>
                <span>切换学习卡</span>
                <Icon type="md-arrow-dropdown" />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem  v-for="(item,index) in additionalDateList" i :key="index" :name='item.studentId'>{{item.className}}</DropdownItem>
                <DropdownItem divided style="text-align:center" name='linkNewCard' > <Icon type="md-add-circle"/>关联新卡</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            </Row>
        </div>

        <div class="header-avator-con">
          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown transfer trigger="hover" @on-click="handleClickUserDropdown">
                <a style="color: #fff">
                  <Avatar :src="avatarPath" style="background: #619fe7;margin-left: .10rem;"></Avatar>
                  <span class="main-user-name">{{ nickName ? nickName : username }}</span>
                  <Icon type="md-arrow-dropdown" />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="ownSpace">{{ '用户中心' }}</DropdownItem>
                  <!-- <DropdownItem name="ownSpaceOld">{{ $t('userCenterOld') }}</DropdownItem> -->
                  <DropdownItem name="changePass" v-if="schoolStatus == 0">
                    {{ '修改密码' }}
                  </DropdownItem>
                  <DropdownItem name="loginout" divided v-if="loginFrom == 1">
                    {{ '退出' }}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Row>
          </div>
          <!-- <message-tip v-model="mesCount"></message-tip> -->
        </div>
      </div>
      <div v-if="flag" class="messageBanner">
        <img src="../assets/messageBanner.png" width="100%" alt />
      </div>
      <!-- 页签 -->
      <div class="tags-con" v-else>
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div>
    </div>
    <!--  :style="{left: shrink?'60px':height}" -->
    <div :class="flag === true ? 'single-page-con1' : 'single-page-con'">
      <div class="single-page">
        <keep-alive :include="cachePage">
          <router-view></router-view>
        </keep-alive>
        <div class="fixedDom">
          <router-link :to="{ path: '../peixun/showScratch' }" target="_blank">
            <div  @click="tracking('1')">
            <img class="create" src="@/assets/quickCreate.png" alt="" style="width: 70%;" />
            </div>
          </router-link>
          <!-- <router-link :to="{ path: '../student/myOpus'}">
            <img class="myOpus" src="@/assets/my_work.png" alt="">
          </router-link> -->
          <router-link :to="{ path: '../upMember' }" v-if="isTrial == 1" target="_blank">
            <img class="create" src="@/assets/plus.png" alt="" />
          </router-link>

          <div >
            <!-- <router-link :to="`./new-side?ak=${encodedAccessToken}`">
              <img class="create" width="150" src="https://dy-static.oss-cn-beijing.aliyuncs.com/temp/newstu/new.png" alt="" />
            </router-link> -->
            <a @click="toNew()">
            <img class="create" width="150" src="https://dy-static.oss-cn-beijing.aliyuncs.com/temp/newstu/new.png" alt="" />
          </a>
          </div>

          
          <!-- <router-link :to="{ path: '../student/myOpus'}">
            <img class="myOpus" src="@/assets/my_work.png" alt="">
          </router-link> -->
        </div>
        </div>
    </div>
      <Modal v-model="linkCardModelShow" :mask-closable="false" class="perfectInfoBox" >
      <div class="out">
        <div class="outL"></div>
        <div class="outR">
          <div class="titInfo">关联往期学习卡</div>
          <Form ref="formData" :model="cardLinkFormData" :label-width="90">
            <FormItem label="学生姓名:" prop="name">
              <Input size="large" clearable v-model="cardLinkFormData.realName" disabled placeholder="请输入姓名" autocomplete="off" />
            </FormItem>
            <FormItem label="所在班级:" prop="birthDayStr">
                <Select filterable placeholder="请选择所在班级" size="large"  v-model="cardLinkFormData.studentId">
                    <Option v-for="(item,index) in otherStudentlDateList" :value="item.studentId" :disabled='item.disabled' :key="index">{{ item.className }}</Option>
                </Select>
            </FormItem>
          </Form>
          <Button type="primary" @click="submitLinkCard()" :loading="submitLoading">提交</Button>
          <div style="width:100%;margin-top:0.2rem;color:#999">
          <p style="font-weight:bold">关联须知</p>
          <p>1、所在班级可模糊搜索。</p>
          <p>2、提交前请核对好您所要关联的卡信息。</p>
          <p>3、若找不到之前的学习卡,请点击右上角修改用户名与之前学习卡的用户名保持一致。</p>
          </div>
        </div>
      </div>
      <div slot="footer">
      </div>
    </Modal>
  </div>
</template>
<script>
import Util from '@/libs/util'
import shrinkableMenu from './main-components/shrinkable-menu/shrinkable-menu.vue'
import tagsPageOpened from './main-components/tags-page-opened.vue'
import breadcrumbNav from './main-components/breadcrumb-nav.vue'
import messageTip from './main-components/message-tip.vue'
import { userInfo } from '../api'
import { getRequest,postRequest,noTokenGetRequest ,noTokenPostRequest } from '@/libs/axios'
import {userInfoSteamCard,showScratchEventTracking} from '@/api/index'
// import Cookies from 'js-cookie'
// import util from '@/libs/util.js'
// import {
//   // getMessageSendData,
//   userInfo
// } from '@/api/index'

export default {
  components: {
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    messageTip
  },
  data() {
    return {

      accessToken:"",
      currCardStatus:true,
      submitLoading: false,
      cardLinkFormData:{},
      cardLinkClassData:[],
      linkCardModelShow:false,
      isTrial: 0,
      userInfo: {},
      identityModal: false,
      height: '',
      shrink: false,
      username: '',
      nickName: '',
      loginFrom:0,
      schoolStatus:0,
      userId: '',
      isFullScreen: false,
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      firstThreeNav: [],
      lastNav: [],
      flag: false,
      additionalDateList:[],
      otherStudentlDateList:[]
    }
  },
  computed: {
    encodedAccessToken() {
      return this.$util.localGet('accessToken');
    },
    navList() {
      return this.$store.state.app.navList
    },
    currNav() {
      return this.$store.state.app.currNav
    },
    currNavTitle() {
      return this.$store.state.app.currNavTitle
    },
    menuList() {
      return this.$store.state.app.menuList
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList // 打开的页面的页面对象
    },
    currentPath() {
      return this.$store.state.app.currentPath // 当前面包屑数组
    },
    avatarPath() {
      return this.$util.localGet('userInfo').avatar
    },
    cachePage() {
      return this.$store.state.app.cachePage
    },
    lang() {
      return this.$store.state.app.lang
    },
    menuTheme() {
      return this.$store.state.app.menuTheme
    },
    mesCount() {
      return this.$store.state.app.messageCount
    }
  },
  stompClient: {
    monitorIntervalTime: 100,
    stompReconnect: true,
    timeout(orgCmd) {}
  },
  methods: {
    toNew(){
        let from = Util.localGet('from');
        if(!from){
          from = 'pc'
        }
       window.open(`https://new-students.xiongbangzhu.com/oldpass?ak=${this.encodedAccessToken}&f=${from}` , '_blank');
    },
     // 获取通知数据
    async _getNotic() {
      this.$Notice.destroy()
      const res = await getRequest("/v3/notice/getMyNoticeList", null, false);
      if (res.result !== null) {
        res.result.forEach(item => {  
            if(item.displayMode == 2){//（1：弹窗提醒 2：侧边提示）
                this.$Notice.info({
                    title: item.title,
                    desc: item.content,
                    duration: 0,
                    top:50,
                    render: h => {
                        if(item.redirectUrlStatus == 0){
                          return h('span', [
                                item.content
                            ])
                        }else{
                            return h('span', [
                                item.content,
                                h('br'),
                                h('br'),
                                h('a',{ 
                                  attrs: {  
                                    href: item.redirectUrl,   
                                    target: '_blank'
                                  }, 
                              }, '快点击前往看看吧~'),
                            ])
                        }
                        
                    },
                    onClose:function(){
                      if(item.displayDuration == 1){
                          //发生关闭请求
                          getRequest(`/v3/notice/closeNotice?id=${item.id}`, null, false);
                      }
                    }
                });
            }
        }); 
      }
    },
    tracking(event){
    console.log(event)
        let params = {
          event,
        }
        showScratchEventTracking(params)
    },
    submitLinkCard(){
      this.submitLoading = true;
      const studentId = this.cardLinkFormData.studentId;
      const name = this.cardLinkFormData.realName;
      if(!studentId){
        this.$Message.error("请选择所在班级");
        this.submitLoading = false;
        return
      }
      let selectStudentArr = this.otherStudentlDateList.filter((item, index,arr)=>{
          return item.studentId == studentId
      });
      const selectStudent = selectStudentArr[0];
      this.$Modal.confirm({
            title: '确定将所选学习卡关联至当前学习卡??',
            content: `<p><span style='font-weight: bolder;margin-top: 0.1rem;'>所选学生: </span>${name}</p>
            <p><span style='font-weight: bolder;'>所在班级: </span>${selectStudent.className}</p>
            <p><span style='font-weight: bolder;'>激活时间: </span>${selectStudent.activeTime}</p>`,
            onOk: () => {
                this.submitLoading = false; 
                this.saveLinkStudent(studentId);  
            },
            onCancel: () => {
                this.submitLoading = false;
            }
        });
    },
    async saveLinkStudent(studentId){
       const result = await postRequest("/v5/steamCard/saveAdditionalCard", {
         "studentId":studentId
       }, false);
        if (result.success) {
          this.$Message.success(result.message);
          this.linkCardModelShow = false;
          this.getLinkCard();
        } 
    },
    toScratch() {},
    toMyOpusList() {},
    init() {
      // 菜单
      let pathArr = this.$util.setCurrentPath(this, this.$route.name)
      // this.$store.commit("updateMenulist");
      if (pathArr.length >= 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      // let userInfo = JSON.parse(Cookies.get('userInfo'))
      let userInfo = this.$util.localGet('userInfo')
      this.userInfo = this.$util.localGet('userInfo')
      this.loginFrom = this.$util.localGet('loginFrom')
      this.username = userInfo.userName
      this.nickName = userInfo.realName
      this.userId = userInfo.id
      //机构状态
      this.schoolStatus = userInfo.schoolStatus;
      if(this.schoolStatus == 1){
        this.getLinkCard();
        this.getOtherStudents();
      }
      this.checkTag(this.$route.name)
      if(this.$util.localGet('currCardStudentId')){
        this.currCardStatus = false;
      }
      // // 读取未读消息数
      // getMessageSendData({
      //   userId: userInfo.id,
      //   status: 0
      // }).then(res => {
      //   if (res.success === true) {
      //     this.$store.commit('setMessageCount', res.result.totalElements)
      //   }
      // })
      // this.connectSrv()
      // this.updateUserInfo() // 更新用户信息
      // this.identityModalShow(); //展示“请选择你的身份弹窗”
    },
    onConnected(frame) {
      // console.log("连接ws成功: " + frame);
      // 订阅广播系统通知
      this.$stompClient.subscribe('/topic/subscribe', this.responseCallback, this.onFailed)
      // 订阅点对点 通过用户id指定用户
      this.$stompClient.subscribe('/user/' + this.userId + '/queue/subscribe', this.responseCallback, this.onFailed)
    },
    onFailed(frame) {
      console.log('连接ws失败： ' + JSON.stringify(frame))
    },
    // connectSrv () {
    //   var headers = {}
    //   this.connetWM(ws, headers, this.onConnected, this.onFailed)
    // },
    responseCallback(frame) {
      // console.log("收到消息：" + frame.body);
      this.$store.commit('setMessageCount', this.mesCount + 1)
    },
    disconnect() {
      this.disconnetWM()
    },
    selectNav(name) {
      this.$store.commit('setCurrNav', name)
      this.setStore('currNav', name)
      // 清空所有已打开标签
      // this.$store.commit("clearAllTags");
      this.$router.push({
        name: 'home_index'
      })
      this.$util.initRouter(this)
    },
    async getLinkCard(){
      const result = await postRequest("/v5/steamCard/getAdditionalList", null, false);
      if (result.success) {
        this.additionalDateList = result.result;
      }
    },
    async getOtherStudents(){
      const result = await postRequest("/v5/steamCard/getOtherStudents", null, false);
      if (result.success) {
        this.otherStudentlDateList = result.result;
      }
    },
    toggleClick() {
      this.shrink = !this.shrink
    },
    handleClickBackMainCard(name){
      const studentId = this.$util.localGet('currCardStudentId');
      this.currCardStatus = true;
      this.loginByStudentUserId(studentId);
      this.$util.localRem('currCardStudentId');
    },
    handleClickAdditionalCardDropdown(name){
      if(name === 'linkNewCard'){
          this.linkCardModelShow = true;
      }else{
        this.currCardStatus = false;
        const studentId = this.$util.localGet('userInfo').id
        this.$util.localSet('currCardStudentId', studentId)
        //1:切换卡,
        //2:存储登录信息
        this.loginByStudentUserId(name);
        //3:刷新页面
      }
    },
    async loginByStudentUserId(studentId){
      const res=await noTokenGetRequest(`/v3/quicklogin/loginById/${studentId}`)
      if(res.code===200){//登录成功 跳转首页
        this.$util.localSet('accessToken', res.result)
        this.$util.localSet('from', 'steamCard')
              // 处理顶部頁签
              this.$store.state.app.pageOpenedList = [
                {
                  title: '首页',
                  path: '',
                  name: 'home_index'
                }
              ]
              // 获取用户信息
              userInfoSteamCard().then(res => {
                if (res.success === true) {
                  this.$util.localSet('userInfo', res.result);
                  this.$store.commit('setAvatarPath', res.result.avatar);
                  this.$util.initRouter(this)
                  // 强制刷新页面 重新加载router
                  location.reload()
                } else {
                  this.loading = false
                }
              })
      }
    },
    handleClickUserDropdown(name) {
      if (name === 'ownSpace') {
        this.$util.openNewPage(this, 'ownspace_index')
        this.$router.push({
          name: 'ownspace_index'
        })
      } else if (name === 'ownSpaceOld') {
        this.$util.openNewPage(this, 'ownspace_old')
        this.$router.push({
          name: 'ownspace_old'
        })
      } else if (name === 'changePass') {
        this.$util.openNewPage(this, 'change_pass')
        this.$router.push({
          name: 'change_pass'
        })
      } else if (name === 'loginout') {
        // 退出登录
        this.$store.commit('logout', this)
        this.$store.commit('clearOpenedSubmenu')
        this.$util.localRem('accessToken')
        this.$util.localRem('loginFrom')
        // 强制刷新页面 重新加载router
        location.reload()
      }
    },
    checkTag(name) {
      let openpageHasTag = this.pageTagsList.some(item => {
        if (item.name === name) {
          return true
        }
      })
      if (!openpageHasTag) {
        //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
        this.$util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {})
      }
    },
    handleSubmenuChange(val) {
      // console.log(val)
    },
    beforePush(name) {
      // console.log(name)
      return true
    },
    fullscreenChange(isFullScreen) {
      // console.log(isFullScreen);
    },
    toPractise(){

      // this.userInfo.accessKey = '1337209402259804161'
      // this.userInfo.secretKey = 'b7kYcACouTpk6zXWz60V5nn6jlznYdnewXAneHBFO1g6oAbVrK2Nu7b423cdmaA0IJZlJCGMT2nlq5OUS8b0Z4o20bHc0H154PdclrjzJcp3rX5By12E5tDlzs3nMgOH9WxMojAac5eJY5nCR9amlnzXQQeJFur9vBBg9BhbaDU='
      // let url = `http://192.168.0.109:9999/?id=${this.userInfo.id}&username=${this.userInfo.userName}&avatar=${this.userInfo.avatar}&accessKey=${this.userInfo.accessKey}&secretKey=${this.userInfo.secretKey}`
      // window.open(url)
    }
    // 去往用户中心
    // toUserCenter() {
    //   console.log('用户中心')
    //   this.$router.push('/student/userCenter')
    // }
  },
  watch: {
    $route(to) {
      this.$store.commit('setCurrentPageName', to.name)
      let pathArr = this.$util.setCurrentPath(this, to.name)
      if (pathArr.length > 2) {
        this.$store.commit('addOpenSubmenu', pathArr[1].name)
      }
      this.checkTag(to.name)
      localStorage.currentPageName = to.name
    },
    lang() {
      this.$util.setCurrentPath(this, this.$route.name) // 在切换语言时用于刷新面包屑
    },
    currentPath(val) {
      // console.log(val[val.length-1].name,'333');
      if (val[val.length - 1].name === 'message_index') {
        this.flag = true
      } else {
        this.flag = false
      }
    }
  },
  mounted() {
    if(this.$util.localGet('studentStatus') == 1){
      this.isTrial = 1;
    }
    this.cardLinkFormData.realName = this.$util.localGet('userInfo').realName;
    this.init()
    this.height = document.body.clientHeight * 0.2765 + 'px'
    this._getNotic();
    this.accessToken = this.$util.localGet('accessToken')
    
  },
  created() {
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
  }
}
</script>

<style scoped lang="less">
.xinxilogo{
  height: 0.8rem !important;
}
.bgImg1 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -0.5rem -0.55rem;
}

.bgImg2 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -2.62rem -0.55rem;
}

.bgImg3 {
  width: 1.8rem;
  /*必设属性*/
  height: 1.8rem;
  /*必设属性*/
  margin: 0.35rem;
  border-radius: 50%;
  cursor: pointer;
  background-image: url('../assets/people.jpg');
  background-repeat: no-repeat;
  background-position: -0.5rem -2.61rem;
}
.fixedDom {
  position: fixed;
  bottom: 1rem;
  right: 0.5rem;
  display: flex;
  flex-direction: column;
  img {
    // width: 1rem;
    // border-radius: 50%;
    // box-shadow: 0 0 0.2rem rgba(0, 0, 0, 0.3);
  }
  .create {
    animation: twinkling 1s infinite ease-in-out;
  }
  
}
@keyframes twinkling {
  0% {
    transform: scale(1);
    // opacity: 1;
  }
  10%,
  20% {
    transform: scale(0.9) rotate(-3deg);
    // opacity: .5;
  }
  30%,
  50%,
  70%,
  90% {
    transform: scale(1.1) rotate(3deg);
    // opacity: .9;
  }
  40%,
  60%,
  80% {
    transform: scale(1.1) rotate(-3deg);
    // opacity: 1;
  }
  100% {
    transform: scale(1) rotate(0);
    // opacity: 1;
  }
}
.fixedDomPractise{
  position: fixed;
  bottom: 2.3rem;
  right: 0.5rem;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  // background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
  background-image: linear-gradient(0deg, #fa709a 0%, #fee140 100%);
  // animation: twinkling 1s infinite ease-in-out;
}

.perfectInfoBox {
  /deep/ .ivu-modal {
    top: 2rem;
    width: 6.5rem!important;
  }
  /deep/ .ivu-modal-mask{
    background-color: rgba(55, 55, 55, 0.8);
  }
  /deep/ .ivu-modal-content {
    border-radius: 0.2rem;
  }
  /deep/ .ivu-modal-body {
    padding: 0;
    // width: 6.3rem;
    height: 4rem;
  }
  /deep/ .ivu-modal-footer {
    display: none;
    overflow: hidden;
  }
  .out {
    display: inline-flex;
    width: 100%;
    height: 100%;
    .outL {
      position: relative;
      width: 2.8rem;
      height: 100%;
      background: url('../assets/ziliao.png') no-repeat left top;
      background-size: 100% 100%;
    }
    .outR {
      position: relative;
      width: 3.5rem;
      height: 100%;
      padding: 0 .2rem;
      display: inline-flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      /deep/ .ivu-form-item{
        margin-bottom: .24rem;
      }
      /deep/ .ivu-form-item-label{
        width: .9rem!important;
        font-size: .14rem;
        padding: .1rem .12rem .1rem 0;
      }
      /deep/ .ivu-form-item-content{
        margin-left: .9rem!important;
        line-height: .32rem;
        font-size: .14rem;
      }
      /deep/ .ivu-input-icon{
        width: .32rem;
        height: .32rem;
        line-height: .32rem;
        font-size: .16rem;
      }
      /deep/ .ivu-input{
        height: .32rem;
        font-size: .14rem;
        padding: .04rem .07rem;
      }
      .titInfo {
        font-size: 0.2rem;
        margin-bottom: 0.2rem;
      }
      /deep/ .ivu-btn {
        width: 80%;
        height: .32rem!important;
      }
      .text {
        position: absolute;
        top: .2rem;
        right: 0.2rem;
        color: #333;
        font-size: 0.12rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Main.vue